import { Component, OnInit} from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../../_services/langhfre.service';
import { NavigationService } from 'src/app/_services/navigation.service';

@Component({
  selector: 'app-how-we-do-it',
  templateUrl: './how-we-do-it.component.html',
  styleUrls: ['./how-we-do-it.component.scss']
})
export class HowWeDoItComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    public navigationService: NavigationService
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle('我們如何打造客製化 AI 模型｜Trinka 客製化 AI 解決方案');
    this.metaTagService.updateTag({ name: 'description', content: "了解 Trinka AI 為企業打造專屬 AI 模型的完整流程。我們依據您的業務目標，開發精準貼合需求的模型，並運用您的專有數據進行建置與優化。" });
    this.metaTagService.updateTag({ property: 'og:title', content: "我們如何打造客製化 AI 模型｜Trinka 客製化 AI 解決方案" });
    this.metaTagService.updateTag({ property: 'og:description', content: "了解 Trinka AI 為企業打造專屬 AI 模型的完整流程。我們依據您的業務目標，開發精準貼合需求的模型，並運用您的專有數據進行建置與優化。" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/enterprise/custom-ai-models/how-we-do-it' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/enterprise/custom-ai-models/how-we-do-it' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '我們如何打造客製化 AI 模型｜Trinka 客製化 AI 解決方案' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "了解 Trinka AI 為企業打造專屬 AI 模型的完整流程。我們依據您的業務目標，開發精準貼合需求的模型，並運用您的專有數據進行建置與優化。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise/custom-ai-models/how-we-do-it' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise/custom-ai-models/how-we-do-it' });

    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
    // console.log("Country is", this.country);
  }

}
